var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"footer__box"},[_c('p',{staticClass:"cp"},[_vm._v(" (c) "+_vm._s(_vm.props.year)+" feedclip. ")])])}
var staticRenderFns = []

export { render, staticRenderFns }